export enum INVESTOR_DOCUMENT_SUBTYPE {
  ID_DOC = 'idDoc',
  TAX_DOC = 'taxDoc',
}
